// TEMPORARY emergency feature flag — hides the still-unfinished /pricing
// page from the public while abuse-prevention work is the priority. This is
// a build-time constant (not a runtime env var like the backend's
// ANONYMOUS_BATTLE_GENERATION) since CRA bakes REACT_APP_* vars in at build
// time — flipping it requires a code change + redeploy. Admin/Owner can
// still reach /pricing regardless, for QA (see PricingPage.js/Header.js).
export const PRICING_PAGE_ENABLED = false;
